import 'twin.macro';
import React, { ComponentProps, PropsWithChildren } from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import Popover from 'components/Popover';
import { ConfirmationPopoverBody, Intent } from './ConfirmationPopoverBody';
import usePopoverContext from 'components/Popover/usePopoverContext';
import { BaseButtonProps } from 'components/Buttons/BaseButtonProps';

function PopoverBody({
  onConfirm,
  bodyTitle,
  bodyDescription,
  confirmButtonTitle,
  backButtonTitle,
  intent = 'warning',
}: {
  onConfirm: () => void;
  bodyTitle: string;
  bodyDescription: string;
  confirmButtonTitle: string;
  backButtonTitle: string;
  intent: Intent;
}) {
  const { close } = usePopoverContext();

  return (
    <ConfirmationPopoverBody
      onConfirm={onConfirm}
      onCancel={() => close?.()}
      bodyTitle={bodyTitle}
      bodyDescription={bodyDescription}
      backButtonTitle={backButtonTitle}
      confirmButtonTitle={confirmButtonTitle}
      intent={intent}
    />
  );
}

interface Props {
  withConfirmation: boolean;
  onConfirm: () => void;
  popoverPlacement?: ComponentProps<typeof Popover>['placement'];
  popoverIntent: Intent;
  bodyTitle: string;
  bodyDescription: string;
  backButtonTitle: string;
  confirmButtonTitle: string;
}

export function ButtonWithConfirmation(
  props: PropsWithChildren<Props & BaseButtonProps>,
) {
  const {
    children,
    withConfirmation,
    onConfirm,
    popoverPlacement = 'bottom',
    popoverIntent,
    bodyTitle,
    bodyDescription,
    backButtonTitle,
    confirmButtonTitle,
    ...buttonProps
  } = props;

  if (!withConfirmation || buttonProps.disabled) {
    return (
      <Button onClick={onConfirm} {...buttonProps}>
        {children}
      </Button>
    );
  }
  return (
    <Popover portal placement={popoverPlacement} offsetInPx={10}>
      <Popover.Button {...buttonProps}>{children}</Popover.Button>
      <Popover.Panel size="2xl">
        <PopoverBody
          intent={popoverIntent}
          onConfirm={onConfirm}
          bodyTitle={bodyTitle}
          bodyDescription={bodyDescription}
          backButtonTitle={backButtonTitle}
          confirmButtonTitle={confirmButtonTitle}
        />
      </Popover.Panel>
    </Popover>
  );
}
